import React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import CircleIcon from '@mui/icons-material/Circle';
import { StepConnector } from '@mui/material';
import { ASPENDENTAL_FONTS } from '../../../constants/constant';

var TAGHorizontalStepperInfo = function TAGHorizontalStepperInfo(_ref) {
  var steps = _ref.steps;
  //NOTE: activeStep will be used when onCLick events are incoporated to each text link
  // const [activeStep, setActiveStep] = useState(currentStep)
  var connector = React.createElement(StepConnector, {
    sx: {
      top: '7.5px',
      '&	.MuiStepConnector-lineHorizontal': {
        border: '1px solid neutrals.primary',
        borderColor: 'neutrals.primary',
        background: '1px solid neutrals.primary',
        backgroundColor: 'neutrals.primary'
      }
    }
  });
  var STEPLABELSTYLE = {
    '.MuiStepLabel-labelContainer': {
      width: '16px'
    },
    '.MuiStepLabel-labelContainer > .MuiStepLabel-alternativeLabel': {
      marginTop: '9px',
      textAlign: 'start'
    }
  };
  var TYPOGRAPHYSTYLE = {
    fontFamily: ASPENDENTAL_FONTS.bodySmallBook.fontFamily,
    fontSize: ASPENDENTAL_FONTS.bodySmallBook.fontSize,
    color: 'secondary.main',
    ':hover': {
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  };
  return React.createElement(Box, {
    sx: {
      width: '100%'
    }
  }, React.createElement(Stepper, {
    connector: connector,
    alternativeLabel: true
  }, steps.map(function (label, index) {
    return React.createElement(Step, {
      key: index
    }, React.createElement(StepLabel, {
      icon: React.createElement(CircleIcon, {
        sx: {
          fontSize: '16px',
          color: 'secondary.main'
        }
      }),
      sx: STEPLABELSTYLE
    }, React.createElement(Typography, {
      sx: TYPOGRAPHYSTYLE
    }, label.text)));
  })));
};

export default TAGHorizontalStepperInfo;